<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待审核" name="1">
      </el-tab-pane>
      <el-tab-pane label="已审核" name="2">
      </el-tab-pane>
      <el-tab-pane label="未通过" name="3">
      </el-tab-pane>
    </el-tabs>

    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10" v-if="activeName === '2'">
        <span class="pr5">状态</span>
        <el-select v-model="status" placeholder="全部" class="w150" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.id"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">分类</span>
        <el-input v-model.trim="classify" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">所属代理商</span>
        <el-input v-model.trim="agent" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">发布人</span>
        <el-input v-model.trim="person" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">资讯标题</span>
        <el-input v-model.trim="title" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="refresh(1)">
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table v-if="activeName === '1'" class="my-table" :data="tableData" v-loading="tableLoading" key="1"
              :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="title" label="资讯标题"></el-table-column>
      <el-table-column align="center" prop="tagsName" label="分类"></el-table-column>
      <el-table-column align="center" prop="userName" label="发布人"></el-table-column>
      <el-table-column align="center" prop="agentName" label="所属代理商"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>

      <el-table-column align="center" width="100" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="msgBtn(row.informationId, 2)">审核</a>
        </template>
      </el-table-column>
    </el-table>

    <el-table v-else-if="activeName === '2'" class="my-table" :data="tableData" v-loading="tableLoading" key="2"
              :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="title" label="资讯标题"></el-table-column>
      <el-table-column align="center" prop="tagsName" label="分类"></el-table-column>
      <el-table-column align="center" prop="userName" label="发布人"></el-table-column>
      <el-table-column align="center" prop="agentName" label="所属代理商"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="browseNum" label="阅读数"></el-table-column>
      <el-table-column align="center" prop="collectionNum" label="收藏数"></el-table-column>
      <el-table-column align="center" prop="commentsNum" label="评论数"></el-table-column>
      <el-table-column align="center" prop="forwardNum" label="转发数"></el-table-column>
      <el-table-column align="center" prop="statusName" label="状态"></el-table-column>
      <el-table-column align="center" label="操作" width="150px">
        <template slot-scope="{row}">
          <a class="glob-a" @click="detailBtn(row.informationId)">查看</a>

          <a class="glob-a" v-if="row.status == '5' || row.status == '6'"
             @click="editBtb(row.informationId, 1)">取消置顶</a>
          <a class="glob-a" v-if="row.status == '2'" @click="editBtb(row.informationId, 2)">置顶</a>
          <a class="glob-a" v-if="row.status != '4'" @click="editBtb(row.informationId, 3)">下架</a>
          <!--          <a class="glob-a" v-else @click="editBtb(row.informationId, 4)">重新发布</a>-->
          <a class="glob-a" v-if="row.status == '6'" @click="editBtb(row.informationId, 5)">消息推送</a>
        </template>
      </el-table-column>
    </el-table>

    <el-table v-else class="my-table" :data="tableData" v-loading="tableLoading" key="3"
              :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="title" label="资讯标题"></el-table-column>
      <el-table-column align="center" prop="tagsName" label="分类"></el-table-column>
      <el-table-column align="center" prop="userName" label="发布人"></el-table-column>
      <el-table-column align="center" prop="agentName" label="所属代理商"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="remark" label="未通过原因"></el-table-column>
      <el-table-column align="center" width="100" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="msgBtn(row.informationId, 1)">查看</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 查看 -->
    <el-dialog :title="msgType === 1 ? '查看' : '审核'" :visible.sync="msgModal" width="800px">
      <el-form label-width="120px">
        <el-form-item label="资讯标题：">
          {{msgData.title}}
        </el-form-item>
        <el-form-item label="正文：">
          <div class="box-height-300">
            {{msgData.context}}
          </div>
        </el-form-item>
        <el-form-item label="封面：">
          <show-img class="mr10" v-for="(item, index) in msgData.coverList" :value="item" :key="index"/>
        </el-form-item>
        <el-form-item label="所属分类：">
          {{msgData.tagsName}}
        </el-form-item>
        <el-form-item label="标签：">
          <el-tag class="mr10" size="medium" v-for="(item, index) in msgData.labels" :key="index">{{item.labelName}}
          </el-tag>
        </el-form-item>
        <el-form-item label="发布人：">
          {{msgData.nickName}}
        </el-form-item>
        <el-form-item label="所属代理商：">
          {{msgData.agentName}}
        </el-form-item>
        <el-form-item label="创建时间：">
          {{msgData.createTime}}
        </el-form-item>
        <el-form-item label="状态：">
          {{msgData.statusName}}
        </el-form-item>
        <el-form-item label="未通过原因：" v-if="msgType === 1">
          {{msgData.remark}}
        </el-form-item>
        <el-form-item label="审核意见：" v-else>
          <el-row>
            <el-col :span="6">
              <el-radio v-model="msgAudit" label="Y">
                审核通过
              </el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio v-model="msgAudit" label="N">
                审核不通过
              </el-radio>

              <el-input
                  class="mt10 w400"
                  resize="none"
                  type="textarea"
                  :rows="4"
                  maxlength="100"
                  :disabled="msgAudit === 'Y'"
                  show-word-limit
                  v-model="msgAuditContent"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>

      <div slot="footer" v-if="msgType === 2">
        <el-button @click="msgModal = false">取 消</el-button>
        <el-button type="primary" @click="msgSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 已通过详情 -->
    <el-dialog title="查看" :visible.sync="detailModal" fullscreen>
      <detail :data="detailData"/>
    </el-dialog>

    <!-- 置顶 -->
    <el-dialog title="置顶" :visible.sync="topData.modal">
      <el-form style="min-height: 200px;">
        <el-form-item label="置顶位置" label-width="100px">
          <el-radio-group v-model="topData.radio">
            <el-radio label="1">全国置顶1</el-radio>
            <el-radio label="2">全国置顶2</el-radio>
            <el-radio label="3">全国置顶3</el-radio>
            <el-radio label="4">全国置顶4</el-radio>
            <el-radio label="5">全国置顶5</el-radio>
          </el-radio-group>
          <div class="mt10">
            <el-radio v-model="topData.radio" label="6">区域置顶</el-radio>

            <el-cascader
                style="width: 500px;"
                ref="refTopCity"
                v-show="topData.radio == '6'"
                v-model="topData.city"
                :options="cityList"
                :props="{value: 'code', label: 'name', multiple: true}"
                clearable
            />
          </div>

        </el-form-item>
        <el-form-item label="置顶日期" label-width="100px">
          <el-date-picker
              v-model="topData.date"
              style="width: 300px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="topData.modal = false">取 消</el-button>
        <el-button type="primary" @click="topSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getInformationAuditWaitPage,
    getInformationAuditFailedPage,
    getInformationAuditSuccessPage,
    getInformationAuditMsg,
    setInformationAuditSuccess,
    setInformationAuditFailed,
    setInformationAuditSoldOut,
    setInformationAuditTop,
    setInformationAuditCancelTop,
    getInformationCityTreeByUserRole
  } from '@/api'

  import ShowImg from '@/components/ShowImg'
  import Detail from '../components/Detail'

  export default {
    name: 'InformationAuth',
    components: {ShowImg, Detail},
    data () {
      return {
        activeName: '1',
        date: [],
        classify: '',
        status: '',
        statusList: [
          {id: '2', name: '已发布'},
          {id: '4', name: '已下架'},
          {id: '5', name: '区域置顶'},
          {id: '6', name: '全国置顶'},
        ],
        person: '',
        title: '',
        agent: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        msgModal: false,
        msgData: {},
        msgType: 1,
        msgAudit: 'Y',
        msgAuditContent: '',
        detailModal: false,
        detailData: {},
        topData: {
          modal: false,
          id: '',
          radio: '1',
          date: [],
          city: []
        },
        cityList: []
      }
    },
    created () {
      this.refresh(1)
      this.getInformationCityTreeByUserRoleFn()
    },
    methods: {
      topSave () {
        let temp = {
          informationId: this.topData.id,
          startTime: this.topData.date && this.topData.date.length ? this.topData.date[0] : '',
          endTime: this.topData.date && this.topData.date.length > 1 ? this.topData.date[1] : '',
        }
        if (this.topData.radio == '6') {
          temp.stickType = 'AREA'
          temp.cityCodes = this.$refs['refTopCity'].getCheckedNodes(true).map(item => item.value)
        } else {
          temp.stickType = 'NATION'
          temp.nationIndex = this.topData.radio
        }
        setInformationAuditTop(temp).then(res => {
          this.$message.success(res.data)
          this.topData.modal = false
          this.refresh(1)
        })
      },
      // 1)取消置顶  2)置顶 3)下架 4)重新发布 5)消息推送
      editBtb (id, t) {
        switch (t) {
          case 1:
            this.$confirm('确认取消置顶吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setInformationAuditCancelTop(id).then(res => {
                this.$message.success(res.data)
                this.refresh(1)
              })
            }).catch(() => {
            })
            break
          case 2:
            this.topData = {
              modal: true,
              radio: '1',
              id,
              date: [],
              city: []
            }
            break
          case 3:
            this.$prompt('下架原因', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /\S/,
              inputPlaceholder: '请输入',
              inputErrorMessage: '请输入'
            }).then(({value}) => {
              setInformationAuditSoldOut({
                informationId: id,
                remark: value
              }).then(res => {
                this.$message.success(res.data)
                this.refresh(1)
              })
            }).catch(() => {
            })
            break
          case 4:
            this.$router.push({name: 'InformationEdit', query: {id}})
            break
          case 5:
            break
        }
      },
      detailBtn (id) {
        getInformationAuditMsg(id).then(res => {
          this.detailModal = true
          this.detailData = res.data
        })
      },
      msgSave () {
        if (this.msgAudit === 'Y') {
          setInformationAuditSuccess({
            informationId: this.msgData.informationId
          }).then(res => {
            this.$message.success(res.data)
            this.msgModal = false
            this.refresh(1)
          })
        } else {
          setInformationAuditFailed({
            informationId: this.msgData.informationId,
            remark: this.msgAuditContent
          }).then(res => {
            this.$message.success(res.data)
            this.msgModal = false
            this.refresh(1)
          })
        }
      },
      msgBtn (id, msgType) {
        this.msgModal = true
        this.msgType = msgType
        this.msgAudit = 'Y'
        this.msgAuditContent = ''
        getInformationAuditMsg(id).then(res => {
          this.msgData = res.data
        })
      },
      handleClick (val) {
        this.refresh(1)
      },
      getInformationAuditWaitPageFn () {
        this.tableLoading = true
        getInformationAuditWaitPage({
          userName: this.person,
          tags: this.classify,
          title: this.title,
          agentName: this.agent,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getInformationAuditFailedPageFn () {
        this.tableLoading = true
        getInformationAuditFailedPage({
          userName: this.person,
          tags: this.classify,
          title: this.title,
          status: this.status,
          agentName: this.agent,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getInformationAuditSuccessPageFn () {
        this.tableLoading = true
        getInformationAuditSuccessPage({
          userName: this.person,
          tags: this.classify,
          title: this.title,
          status: this.status,
          agentName: this.agent,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.refresh()
      },
      refresh (page) {
        page && (this.pages.page = page)

        switch (this.activeName) {
          case '1':
            this.getInformationAuditWaitPageFn()
            break
          case '2':
            this.getInformationAuditSuccessPageFn()
            break
          case '3':
            this.getInformationAuditFailedPageFn()
            break
        }
      },
      getInformationCityTreeByUserRoleFn () {
        getInformationCityTreeByUserRole().then(res => {
          this.cityList = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .box-height-300 {
    max-height: 300px;
    overflow: auto;
  }
</style>
